import { useIntl } from "react-intl";

export function useWorkspaceSignalsHeaderBackTitle() {
  const intl = useIntl();
  return intl.formatMessage({
    defaultMessage: "All Signals",
    description: "WorkspaceSignalsOccasion headerBackTitle",
  });
}
